import React, { PropsWithChildren, useCallback, useEffect } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { CSSTransitionProps } from "react-transition-group/CSSTransition";
import useMedia from "../lib/hooks/useMedia";

interface CarouselProps {
  children: React.ReactNode;
}

const Fade = ({
  children,
  ...props
}: PropsWithChildren<Partial<CSSTransitionProps>>) => (
  <CSSTransition {...props} timeout={300} classNames="fade absolute inset-0">
    {children}
  </CSSTransition>
);

export default function Carousel(props: CarouselProps) {
  const [activeStep, setActiveStep] = React.useState(0);
  const { children } = props;
  const numChildren = React.Children.count(children);
  const { matchesDesktop } = useMedia();

  const handleInfiniteCarousel = useCallback(() => {
    if (activeStep === numChildren - 1) {
      return setActiveStep(0);
    }
    setActiveStep((prevActiveStep) => {
      return prevActiveStep + 1;
    });
  }, [activeStep, numChildren]);

  useEffect(() => {
    const interval = setInterval(handleInfiniteCarousel, 1800);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  return (
    <div
      className="relative flex flex-col items-center space-y-4"
      style={{
        minWidth: matchesDesktop ? 400 : 240,
        minHeight: matchesDesktop ? 400 : 240,
      }}
    >
      <TransitionGroup className="w-full h-full">
        {React.Children.map(children, (child, index) => {
          if (index === activeStep) {
            return <Fade key={index}>{child}</Fade>;
          }
        })}
      </TransitionGroup>
    </div>
  );
}
